import './MptcfeLib.js'
import '../less/main.less'
import article_video_immerse from './article_video_immerse/index'
import collection from './collection'
import Util from '../_utils/util.js'
import plugin from "./plugin"
import Cookie from 'js-cookie'
import goSpecialUrl from '../_utils/go-special-url'
window.EVENT_BUS = Util.eventBus
window.goSpecialUrl = goSpecialUrl;

var params = Util.parseURL(window.location.href);
if(params._trans_){
    Cookie.set('_trans_', params._trans_, { expires: 7 });
}
window.h5_sohu = {
    article_video_immerse,
    collection,
};
window.h5_sohu.plugin = plugin

